<template>
    <el-card>
        <div slot="header">
            <span class="top_title">新增订货</span>
        </div>
        <div class="searchItem">
            <Customer
                ref="ccc"
                :orderForm="orderForm"
                :tips="true"
                :createAlllow="true"
                :allowAddCustomer="true"
                @change="selectCustomer"
            ></Customer>
            <div class="search">
                <span class="searchtips">销售员:</span>
                <el-select
                    v-model="orderForm.empname"
                    placeholder=""
                    @change="selectEmployee"
                    style="width:180px"
                    @visible-change="$forceUpdate()"
                >
                    <el-option
                        v-for="(item, index) in saleList"
                        :key="index"
                        :value="item.id"
                        :label="item.name"
                        style="
                            height: 40px;
                            padding: 10px;
                            line-height: 20px;
                        "
                    />
                </el-select>
                <span style="position: relative;right: 25px;background: #fff;cursor: pointer;" @click="empSetDefault"
                    ><i class="el-icon-more"
                /></span>
            </div>
            <div class="search">
                <span class="searchtips">是否已结算:</span>
                <el-switch
                    v-model="orderForm.payed"
                    :active-value="1"
                    :inactive-value="0"
                /> 
            </div>
            <div class="search" v-if="$common.hasLimits('orderOpen')">
                <span class="searchtips">是否已确认:</span> 
                <el-switch
                    v-model="orderForm.state"
                    :active-value="1"
                    :inactive-value="0"
                />
            </div>
            <div class="search">
                <span class="searchtips">订货日期:</span>
                <el-date-picker
                    v-model="orderForm.date"
                    type="datetime"
                    placeholder="订货日期"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm"
                    :default-value="now"
                    style="width: 180px"
                    :editable="false"
                    @change="changedate"
                />
            </div>
            <div class="search">
                <span class="searchtips">交货日期:</span> 
                <el-date-picker
                    v-model="orderForm.expect"
                    type="datetime"
                    placeholder="交货日期"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm"
                    :default-value="now"
                    style="width: 180px"
                    :editable="false"
                    @change="changedate"
                />
            </div>
            <div class="search">
                <span class="searchtips">发票类型:</span> 
                <el-select
                    ref="invoiceCheck"
                    v-model="orderForm.invoicetype"
                    placeholder="请选择"
                    :disabled="!orderForm.cid"
                    @change="invoiceChange"
                    style="width: 180px"
                >
                    <el-option
                        v-for="item in invoicetypes"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    />
                </el-select>
            </div>
            <div class="number_size">
                <div style="padding-right:10px">订单编号:{{orderForm.number}}</div>
                <el-button @click="openDraft" v-if="$common.hasLimits('order')">打开草稿</el-button>
            </div>
        </div>
        
        <el-form
            ref="orderForm"
            :inline="true"
            :model="orderForm"
            label-width="100px"
            v-if="orderForm.cid>0"
        >
            <el-table
                v-loading="listLoading"
                :data="orderForm.detailL"
                border
                fit
                highlight-current-row
                show-summary
                :summary-method="getSummaries"
                :max-height="437"
                style="width: 100%"
                :header-cell-style="{ 'background-color': '#F5F7FA' }"
                @cell-click="editCell"
            >

                <el-table-column align="center" label="操作" width="120">
                    <template slot-scope="{ row }">
                        <el-button
                            size="mini"
                            icon="el-icon-plus"
                            circle
                            @click="addRow(row)"
                        />
                        <el-button
                            size="mini"
                            icon="el-icon-delete"
                            type="danger"
                            circle
                            @click="removeRow(row)"
                        />
                    </template>
                </el-table-column>

                <template v-for="(col, index) in cols">
                    <el-table-column
                        v-if="col.show"
                        :key="index"
                        :label="col.label"
                        :width="col.width"
                        :align="col.align"
                        :min-width="col.min_width"
                        :class-name="col.class"
                    >
                        <template slot-scope="{ row, column }">
                            <template v-if="col.edit">
                                <template v-if="col.type === 'selectEdit'">
                                    <template v-if="row[col.edit]">
                                        <el-select
                                            ref="editCell"
                                            v-model="row[col.prop]"
                                            placeholder="请输入商品编号或商品名称"
                                            filterable
                                            remote
                                            value-key="id"
                                            style="width: 100%"
                                            :remote-method="getProduct"
                                            @visible-change="$forceUpdate()"
                                            @click.native.stop="cancelCell(row)"
                                            @change="
                                                chooseSpecs($event, row, column)
                                            "
                                            @keyup.enter.native="
                                                cancel(row, column)
                                            "
                                            @blur="getData(row, column)"
                                        >
                                            <el-row
                                                style="
                                                    width: 600px;
                                                    height: 40px;
                                                    line-height: 40px;
                                                    background: #d6d7d9;
                                                "
                                            >
                                                <el-col
                                                    :span="5"
                                                    :offset="2"
                                                    style="
                                                        font-size: 14px;
                                                        text-align: left;
                                                    "
                                                    >商品编号</el-col
                                                >
                                                <el-col
                                                    :span="9"
                                                    style="
                                                        font-size: 14px;
                                                        text-align: left;
                                                    "
                                                    >商品名称</el-col
                                                >
                                                <el-col
                                                    :span="3"
                                                    style="
                                                        font-size: 14px;
                                                        text-align: left;
                                                    "
                                                    >颜色</el-col
                                                >
                                                <el-col
                                                    :span="3"
                                                    style="
                                                        font-size: 14px;
                                                        text-align: left;
                                                    "
                                                    >尺码</el-col
                                                >
                                            </el-row>
                                            <el-option
                                                v-for="(
                                                    item, index1
                                                ) in productList"
                                                :key="index1"
                                                :label="
                                                    item.number +
                                                    ' ' +
                                                    item.name +
                                                    (item.color !== ''
                                                        ? '_' + item.color
                                                        : '') +
                                                    (item.size !== ''
                                                        ? '_' + item.size
                                                        : '')
                                                "
                                                :value="item"
                                                style="
                                                    width: 600px;
                                                    height: 40px;
                                                    padding: 0;
                                                "
                                            >
                                                <el-row
                                                    style="
                                                        width: 600px;
                                                        height: 40px;
                                                        line-height: 40px;
                                                    "
                                                >
                                                    <el-col
                                                        :span="5"
                                                        :offset="2"
                                                        style="
                                                            font-size: 14px;
                                                            text-align: left;
                                                        "
                                                    >
                                                        {{ item.number }}
                                                    </el-col>
                                                    <el-col
                                                        :span="9"
                                                        style="
                                                            font-size: 14px;
                                                            text-align: left;
                                                        "
                                                    >
                                                        {{ item.name }}
                                                    </el-col>
                                                    <el-col
                                                        :span="3"
                                                        style="
                                                            font-size: 14px;
                                                            text-align: left;
                                                        "
                                                    >
                                                        {{ item.color }}
                                                    </el-col>
                                                    <el-col
                                                        :span="3"
                                                        style="
                                                            font-size: 14px;
                                                            text-align: left;
                                                        "
                                                    >
                                                        {{ item.size }}
                                                    </el-col>
                                                </el-row>
                                            </el-option>
                                        </el-select>
                                        <span
                                            class="productList"
                                            @click="productMany(row)"
                                            ><i class="el-icon-more"
                                        /></span>
                                    </template>
                                    <div v-else>
                                        <div>{{ row[col.prop] }}</div>
                                        <div style="font-size:12px" v-if="row[col.prop]&&$common.hasLimits('stockInfo')" :class="{'red':row.stock-row.notSendUnit-row.unit<row.minstock}">库存:{{row.mdesc}} 未发:{{row.ndesc}}</div>
                                        <div style="font-size:12px" v-if="row[col.prop]&&$common.hasLimits('stockInfo')" :class="{'red':row.stock-row.notSendUnit-row.unit<row.minstock}">可用库存:{{row.edesc}}</div>
                                    </div>
                                </template>
                                <template
                                    v-else-if="
                                        col.edit === 'smallEdit' ||
                                        col.edit === 'countEdit'
                                    "
                                >
                                    <el-input
                                        v-if="row[col.edit]"
                                        ref="editCell"
                                        v-model="row[col.prop]"
                                        @click.native.stop="cancelCell(row)"
                                        @blur="cancel(row, column)"
                                        @keyup.enter.native="
                                            cancel(row, column)
                                        "
                                        @input="changeNum($event,row,col.edit)"
                                    />
                                    <span v-else>{{ row[col.prop] }}</span>
                                </template>
                                <template v-else-if="col.type === 'input'">
                                    <el-input
                                        v-if="row[col.edit]"
                                        ref="editCell"
                                        v-model="row[col.prop]"
                                        @click.native.stop="cancelCell(row)"
                                        @blur="cancel(row, column)"
                                        @keyup.enter.native="
                                            cancel(row, column)
                                        "
                                        type="number"
                                        :min="0"
                                        @input="changeMoney($event,row)"
                                    />
                                    <span v-else>{{ row[col.prop] }}</span>
                                </template>
                                <template v-else-if="col.type === 'icon'">
                                    <el-input
                                        v-if="row[col.edit]"
                                        ref="editCell"
                                        v-model="row[col.prop]"
                                        maxlength="20"
                                        @click.native.stop="cancelCell(row)"
                                        @blur="cancel(row, column)"
                                        @keyup.enter.native="
                                            cancel(row, column)
                                        "
                                    />
                                    <span v-else-if="row[col.prop]">{{
                                        row[col.prop]
                                    }}</span>
                                    <div v-else>
                                        <i class="el-icon-edit-outline" />
                                    </div>
                                </template>
                            </template>
                            <template v-else>
                                <template v-if="col.type === 'image'">
                                    <el-image
                                        v-if="row[col.prop].length > 0"
                                        style="width: 30px"
                                        :src="row[col.prop][0]"
                                        :preview-src-list="row[col.prop]"    
                                    >
                                        <template #error>
                                            <div class="errorFonts_mini">暂无图片</div>
                                        </template>
                                    </el-image>
                                    <div v-else-if="row.name" class="errorFonts_mini">暂无图片</div>
                                </template>
                                <template v-else>{{ row[col.prop] }}</template>
                            </template>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
            <div class="searchItem" style="margin-top:20px">
                <div class="search">
                    <span class="searchtips">优惠金额(元)</span>
                    <el-input v-model="orderForm.free" style="width:150px" type="number" :min="0" @input="$common.checkMoney($event,orderForm,'free')"/>
                </div>
                <div class="search">
                    <span class="searchtips">收款金额(元)</span>
                    <el-input v-model="orderForm.pay" style="width:150px" type="number" :min="0" @input="$common.checkMoney($event,orderForm,'pay')"/>
                </div>
                <div class="search">
                    <span class="searchtips">结算账号</span>
                    <el-select
                        v-model="orderForm.accountid"
                        placeholder=""
                        value-key="id"
                        default-first-option
                        popper-class="select-option"
                        style="width:180px"
                        @visible-change="$forceUpdate()"
                        @change="setAccount"
                    >
                        <el-option
                            v-for="(item, index) in acList"
                            :key="index"
                            :value="item.id"
                            :label="item.name + '-' + item.account"
                            style="height: 40px; line-height: 40px"
                        />
                    </el-select>
                    <span @click="accountListDialog = true" style="position: relative;right: 25px;background: #fff;cursor: pointer;"
                        ><i class="el-icon-more"></i></span>
                </div>
                <div class="search" v-if="$global.useinstall==1">
                    <span class="searchtips">货运方式:</span>
                    <el-select v-model="orderForm.method" style="width:180px">
                        <el-option value="自提" label="自提"></el-option>
                        <el-option value="车辆运送" label="车辆运送"></el-option>
                        <el-option value="物流" label="物流"></el-option>
                    </el-select>
                </div>
                <div class="search">
                <span class="searchtips" style="line-height:60px">备注:</span>
                <el-input
                    v-model="orderForm.remark"
                    type="textarea"
                    maxlength="100"
                    style="width: 480px"
                />
            </div>
            </div>
            
            <div v-if="$global.useinstall==1">
                <span class="searchtips">安装地址</span>
                <el-input maxlength="200" style="width:480px" v-model="orderForm.address"></el-input>
            </div>
            <div>
                <div>
                    <Address ref='paddr' @setContact='setContact' :cid='orderForm.cid' :contact='orderForm.contact'></Address>
                </div>
                <div v-show="orderForm.invoicetype>0">
                    <span class="searchtips">发票信息</span>
                    <el-button
                        type="text"
                        icon="el-icon-edit"
                        @click="invoiceDialog = true"
                    />
                    <span
                        v-if="orderForm.invoicetype == 1"
                        class="el-upload__tip"
                        >发票抬头：{{ orderForm.invoice }}，纳税人识别号：{{
                            orderForm.taxidentification
                        }}</span
                    >
                    <span
                        v-else-if="orderForm.invoicetype == 2"
                        class="el-upload__tip"
                        >发票抬头：{{ orderForm.invoice }}，纳税人识别号：{{
                            orderForm.taxidentification
                        }}， 地址:{{ orderForm.invoiceaddress }}，电话：{{
                            orderForm.invoicephone
                        }}，开户银行：{{ orderForm.bankname }}，银行账号：{{
                            orderForm.bankaccountnumber
                        }}</span
                    >
                </div>
            </div>
            <el-row style="margin-top: 20px; text-align: center">
                <el-button
                    type="info"
                    @click="saveAsDraft"
                    v-if="$common.hasLimits('orderDraft')"
                    >保存为草稿</el-button
                >
                <el-button type="primary" @click="checkCustomer"
                    >保存订货单</el-button
                >
            </el-row>
        </el-form>
        <template>
            <!--列表-->
            <el-dialog :visible.sync="accountListDialog" title="结算账号列表" width="60%">
                <account-list
                    ref="accountList"
                    @close="closeAccount(arguments)"
                />
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="accountSelected"
                        >确认</el-button
                    >
                    <el-button @click="accountListDialog = false"
                        >取消</el-button
                    >
                </div>
            </el-dialog>
            <el-dialog :visible.sync="saleListDialog" title="销售员列表" width="60%">
                <sale-list
                    ref="saleList"
                    :emp="orderForm.emp"
                    @close="closeEmployee(arguments)"
                />
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="employeeSelected"
                        >确认</el-button
                    >
                    <el-button @click="saleListDialog = false">取消</el-button>
                </div>
            </el-dialog>
            <el-dialog
                :visible.sync="productListDialog"
                title="商品列表"
                width="90%"
            >
                <pro-list ref="proList" :cid='orderForm.cid' @close="closeProductList(arguments)" />
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="proSelected"
                        >确认</el-button
                    >
                    <el-button @click="productListDialog = false"
                        >取消</el-button
                    >
                </div>
            </el-dialog>
            <el-dialog :visible.sync="invoiceDialog" title="发票信息更改/补充" width="60%">
                <el-form
                    ref="invoiceform"
                    :inline="true"
                    :model="invoiceform"
                    :rules="invoicerules"
                >
                    <el-form-item
                        label="发票抬头"
                        prop="invoice"
                        :label-width="formLabelWidth"
                    >
                        <el-input
                            v-model="invoiceform.invoice"
                            maxlength="100"
                            style="width: 240px"
                        />
                    </el-form-item>
                    <el-form-item
                        label="纳税人识别号"
                        prop="taxIdentification"
                        :label-width="formLabelWidth"
                    >
                        <el-input
                            v-model="invoiceform.taxIdentification"
                            maxlength="50"
                            style="width: 240px"
                        />
                    </el-form-item>
                    <el-form-item
                        v-if="orderForm.invoicetype == 2"
                        label="地址"
                        :label-width="formLabelWidth"
                        prop="invoiceaddress"
                    >
                        <el-input
                            v-model="invoiceform.invoiceaddress"
                            maxlength="80"
                            style="width: 240px"
                        />
                    </el-form-item>
                    <el-form-item
                        v-if="orderForm.invoicetype == 2"
                        label="电话"
                        :label-width="formLabelWidth"
                        prop="invoicephone"
                    >
                        <el-input
                            v-model="invoiceform.invoicephone"
                            maxlength="20"
                            style="width: 240px"
                        />
                    </el-form-item>
                    <el-form-item
                        v-if="orderForm.invoicetype == 2"
                        label="开户银行"
                        :label-width="formLabelWidth"
                        prop="bankname"
                    >
                        <el-input
                            v-model="invoiceform.bankname"
                            maxlength="50"
                            style="width: 240px"
                        />
                    </el-form-item>
                    <el-form-item
                        v-if="orderForm.invoicetype == 2"
                        label="银行账号"
                        :label-width="formLabelWidth"
                        prop="bankaccountnumber"
                    >
                        <el-input
                            v-model="invoiceform.bankaccountnumber"
                            maxlength="50"
                            style="width: 240px"
                        />
                    </el-form-item>
                    <el-form-item
                        style="
                            display: block;
                            text-align: center;
                            padding-top: 20px;
                        "
                    >
                        <el-button type="primary" @click="saveInvoice"
                            >确认</el-button
                        >
                        <el-button @click="cancelInvoice">取消</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>
        </template>
        <ReportOrder ref="roder" :printCol="selectCols"></ReportOrder>
    </el-card>
</template>

<script>
import Customer from '@/components/customer';
import proList from "@/components/product/list";
import saleList from "@/components/sale/list";
import accountList from "@/components/capital/list";
import ReportOrder from '../../components/printshare/reportorder.vue';
import Address from "../../components/place/index.vue";
import InstallPlace from "../../components/installplace/index.vue";
export default {
    components: {
        accountList,
        saleList,
        proList,
        Customer,
        ReportOrder,
        Address,
        InstallPlace,
    },
    data() {
        return {
            imgProfit: this.$api.baseURL,
            addOrderId:0,
            orderForm: {
                cid: -1,
                contact: 0,
                number: "",
                emp: "",
                empname: "",
                cname: " ",
                invoicetype: 0,
                invoice: "",
                invoiceaddress: "",
                invoicephone: "",
                bankname: "",
                bankaccountnumber: "",
                taxidentification: "",
                payed: "",
                state: 0,
                accountid: "",
                accountname: "",
                date: this.$common.format(new Date()),
                expect: "",
                remark: "",
                pri: "",
                detailL: "",
                attachL: [],
                pay: "",
                free: (0.0).toFixed(2),
                address:'',
                method:'',
            },
            cols: [
                {
                    prop: "name",
                    label: "商品名称",
                    edit: "nameEdit",
                    type: "selectEdit",
                    min_width: 200,
                    show: true,
                    sumUp: "合计",
                },
                // {
                //   prop: 'color',
                //   label: '颜色',
                //   edit: '',
                //   type: '',
                //   width: '',
                //   show: true
                // },
                // {
                //   prop: 'size',
                //   label: '尺码',
                //   edit: '',
                //   type: '',
                //   width: '',
                //   show: true
                // },
                {
                    prop: "image",
                    label: "图片",
                    edit: "",
                    type: "image",
                    width: 55,
                    align: "center",
                    show: true,
                    sumUp: "",
                },
                {
                    prop: "packing",
                    label: "包装单位",
                    edit: "",
                    type: "",
                    width: 85,
                    show: true,
                    sumUp: "",
                },
                {
                    prop: "count",
                    label: this.$global.pack+"数",
                    edit: "countEdit",
                    type: "input",
                    width: 220,
                    show: this.$global.buyType!=2?true:false,
                    sumUp: "sum.0",
                },
                {
                    prop: "small",
                    label: this.$global.unit+"数",
                    edit: "smallEdit",
                    type: "input",
                    width: 160,
                    show: this.$global.buyType!=1?true:false,
                    sumUp: "sum.0",
                },
                {
                    prop: "unit",
                    label: "总双数",
                    edit: "",
                    type: "",
                    width: "",
                    show: this.$global.buyType==0?true:false,
                    sumUp: "sum.0",
                    width: 160,
                },
                {
                    prop: "price",
                    label: "单价(元)",
                    edit: "priceEdit",
                    type: "input",
                    width: "",
                    show: true,
                    sumUp: "",
                },
                {
                    prop: "sum",
                    label: "总价(元)",
                    edit: "",
                    type: "",
                    width: "",
                    show: true,
                    sumUp: "sum.2",
                },
                {
                    prop: "remark",
                    label: "备注",
                    edit: "remarkEdit",
                    type: "icon",
                    min_width: 200,
                    align: "center",
                    show: true,
                    sumUp: "",
                },
            ],
            acList: [],
            listLoading: false,
            loading: false,
            productDialog: false,
            saleListDialog: false,
            now: new Date(),
            productList: [],
            saleList: [],
            number: 3,
            invoicetypes: [
                {
                    value: 0,
                    label: "不开发票",
                },
                {
                    value: 1,
                    label: "增值税普通发票",
                },
                {
                    value: 2,
                    label: "增值税专用发票",
                },
            ],
            invoiceDialog: false,
            invoiceform: {
                invoice: "",
                taxIdentification: "",
                invoiceaddress: "",
                invoicephone: "",
                bankname: "",
                bankaccountnumber: "",
            },
            invoicerules: {
                invoice: [
                    {
                        required: true,
                        message: "请输入发票抬头",
                    },
                ],
                taxIdentification: [
                    {
                        required: true,
                        message: "请输入纳税人识别号",
                    },
                ],
                invoiceaddress: [
                    {
                        required: true,
                        message: "请输入联系地址",
                    },
                ],
                invoicephone: [
                    {
                        required: true,
                        message: "请输入手机号",
                    },
                ],
                bankname: [
                    {
                        required: true,
                        message: "请输入开户银行",
                    },
                ],
                bankaccountnumber: [
                    {
                        required: true,
                        message: "请输入开户银行账号",
                    },
                ],
            },
            formLabelWidth: "120px",
            accountListDialog: false,
            accountSelect: "",
            productListDialog: false,
            curRow: {},
            selectCols:'',
        };
    },
    created() {
        this.getList();
        this.getNumber();
        this.getEmpInfo();
        this.getEmployee();
        this.getAccount();
        if(this.$global.cid>0){
            this.selectCustomer(this.$global.cid);
        }
        let temp = localStorage.getItem("orderCols");
        if(temp){
            let arr = JSON.parse(temp);
            if(arr&&arr.length>0){
                this.selectCols=arr.join(',');
            }
        }
    },
    methods: {
        cancelCell(row) {},
        saveAsDraft() {
            this.orderForm.type = 0;
            this.checkCustomer();
        },
        setContact(id){
            this.orderForm.contact = id;
        },
        openDraft() {
            if(this.$common.hasLimits("order")){
                this.$router.push({
                    path: "/order",
                    query: {
                        type: 0,
                    },
                });
            }else{
                this.$router.push("/product");
            }
        },
        getAccount() {
            this.$api.companygetCompanyAccount().then((res) => {
                this.acList = res.data.data;
                let index = 0;
                for(let i in this.acList){
                    if(this.acList[i].isdefault==1){
                        index = i;
                        break;
                    }
                }
                this.orderForm.accountid = this.acList[index].id;
                this.orderForm.accountname = this.acList[index].name;
            });
        },
        getProduct(val) {
            let obj = {
                cid:this.orderForm.cid,
                valid:1,
            }
            if(val){
                obj.product=val;
            }
            this.listLoading = true;
            this.$api.listProductW(obj).then((res) => {
                this.productList = [];
                res.data.data.map((item) => {
                    let tempurl =  item.img.length>0?(this.imgProfit+item.img[0]):"";
                    if (item.specs.length > 0) {
                        item.specs.map((spec) => {
                            if(spec.img.length>0){
                                spec.img = spec.img.map((im) => {
                                    return this.imgProfit + im;
                                });
                            }else{
                                spec.img.push(tempurl);
                            }
                            spec.number = item.number;
                            spec.name = item.name;
                            spec.pid = item.id;
                            spec.spid = spec.id;
                            spec.packing = spec.unit+this.$global.unit+'/'+this.$global.pack;
                            spec.unitCount = spec.unit;
                            this.productList.push(spec);
                        });
                    } else {
                        var spec = {
                            img:[],
                            number: item.number,
                            name: item.name,
                            pid: item.id,
                            packing: item.unit + "双/" + item.packing,
                            unitCount: item.unit,
                            price: item.price,
                            color: "",
                            size: "",
                        };
                        spec.img.push(tempurl);
                        this.productList.push(spec);
                    }
                });
                this.listLoading = false;
            });
        },
        getEmployee() {
            this.$api.employeelistEmployee().then((res) => {
                this.saleList = res.data.data;
            });
        },
        getNumber() {
            this.$api.ordergetOnumber().then((res) => {
                this.orderForm.number = res.data.data;
            });
        },
        getEmpInfo() {
            this.$api.homeGetEmpInfo().then((res) => {
                this.orderForm.emp = res.data.data.id;
                this.orderForm.empname = res.data.data.name;
            });
        },
        getList() {
            this.listLoading = true;
            var dataItems = [];
            for (let i = 0; i < this.number; i++) {
                dataItems.push({
                    id: "",
                    image: [],
                    name: "",
                    packing: "",
                    count: "",
                    small: "",
                    price: "",
                    sum: "",
                    remark: "",
                });
            }
            this.orderForm.detailL = dataItems.map((v) => {
                var that = this;
                this.cols.map((col) => {
                    if (col.edit) {
                        that.$set(v, col.edit, false);
                    }
                });
                return v;
            });
            for (let i = 0; i < this.orderForm.detailL.length; i++) {
                this.orderForm.detailL[i].id = i + 1;
            }
            this.listLoading = false;
        },
        addRow(row) {
            this.number++;
            this.orderForm.detailL.splice(row.id, 0, {
                id: "",
                image: [],
                name: "",
                packing: "",
                count: "",
                small: "",
                price: "",
                sum: "",
                remark: "",
            });
            this.orderForm.detailL.map((v) => {
                var that = this;
                this.cols.map((col) => {
                    if (col.edit) {
                        that.$set(v, col.edit, false);
                    }
                });
                return v;
            });
            for (let i = 0; i < this.orderForm.detailL.length; i++) {
                this.orderForm.detailL[i].id = i + 1;
            }
        },

        removeRow(row) {
            this.number--;
            if (this.number > 0) {
                this.orderForm.detailL.splice(parseInt(row.id) - 1, 1);
            } else {
                this.orderForm.detailL.splice(parseInt(row.id) - 1, 1, {
                    id: "",
                    image: [],
                    name: "",
                    packing: "",
                    count: "",
                    small: "",
                    price: "",
                    sum: "",
                    remark: "",
                });
                this.orderForm.detailL.map((v) => {
                    var that = this;
                    this.cols.map((col) => {
                        if (col.edit) {
                            that.$set(v, col.edit, false);
                        }
                    });
                    return v;
                });
                this.number = 1;
            }
            for (let i = 0; i < this.orderForm.detailL.length; i++) {
                this.orderForm.detailL[i].id = i + 1;
            }
        },
        createFilter(queryString) {
            return (restaurant) => {
                return restaurant.value.indexOf(queryString.toLowerCase()) >= 0;
            };
        },
        invoiceChange() {
            if (this.orderForm.invoicetype == 1) {
                // 普通发票 需：发票抬头，纳税人识别号
                if (
                    !this.orderForm.invoice ||
                    !this.orderForm.taxidentification
                ) {
                    this.$notify({
                        title: "发票信息未完善",
                        message: "请完善信息",
                        type: "warning",
                        duration: 2000,
                        onClose: () => {
                            this.invoiceDialog = true;
                        },
                    });
                }
            } else if (this.orderForm.invoicetype == 2) {
                // 专业发票 需：发票抬头，纳税人识别号，地址，电话，开户银行，开户账号
                if (
                    !this.orderForm.invoice ||
                    !this.orderForm.taxidentification ||
                    !this.orderForm.invoiceaddress ||
                    !this.orderForm.invoicephone ||
                    !this.orderForm.bankname ||
                    !this.orderForm.bankaccountnumber
                ) {
                    this.$notify({
                        title: "发票信息未完善",
                        message: "请完善信息",
                        type: "warning",
                        duration: 2000,
                        onClose: () => {
                            this.invoiceDialog = true;
                        },
                    });
                }
            }
        },
        editCell(row, column) {
            this.cols.map((col) => {
                if (col.label === column.label) {
                    row[col.edit] = !row[col.edit];
                }
            });
            setTimeout(() => {
                this.$nextTick(() => {
                    if (this.$refs.editCell && this.$refs.editCell.length > 0) {
                        this.$refs.editCell[0].focus();
                    }
                });
            }, 200);
        },
        chooseSpecs($event, row, column) {
            this.cols.map((col) => {
                if (col.label === column.label) {
                    var canUseUnit = $event.stock - $event.notSendUnit;
                    var spec = $event.color?"-"+$event.color +"-" +$event.size:"";
                    row.pid = $event.pid;
                    row.spid = $event.spid;
                    row.packing = $event.packing;
                    row.image = $event.img;
                    row.price = $event.price;
                    row.unitCount = $event.unitCount;
                    row.count = 0;
                    row.small = 0;
                    row.minstock = $event.minstock;
                    row.notSendUnit = $event.notSendUnit;
                    row.mdesc = this.$common.changeNumDesc($event,'stockAmount','stockParts','stock');
                    row.ndesc = this.$common.changeNumDesc($event,'notSendAmount','notSendParts','notSendUnit');
                    row.edesc = this.$common.changeSendDesc(canUseUnit,$event.unit);
                    row.stock = $event.stock;
                    row[col.prop] =
                        $event.number +
                        " " +
                        $event.name + spec;
                    row[col.edit] = false;
                }
            });
        },
        getData(row, column) {
            setTimeout(() => {
                this.cols.map((col) => {
                    if (col.label === column.label) {
                        row[col.edit] = false;
                    }
                });
            }, 100);
        },
        cancel(row, column) {
            setTimeout(() => {
                this.cols.map((col) => {
                    if (col.label === column.label) {
                        row[col.edit] = false;
                    }
                });
            }, 100);
        },
        createEmployee() {
            this.$nextTick(() => {
                this.$refs.addEmployee.saveClose("addForm");
            });
        },
        changeMoney(e,row){
            this.$common.checkMoney(e,row,"price");
            row.sum = (row.unit*row.price).toFixed(2);
        },
        changeNum(e,row,cc){
            let key = parseInt(e);
            if(!key||key<0){
                key = 0;
            }else if(key>100000){
                key = 100000;
            }
            if(cc == "countEdit"){
                row.count = key;
            }else{
                row.small = key;
            }
            row.unit = row.count * row.unitCount + row.small;
            row.sum = (row.unit*row.price).toFixed(2);
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            const sumCol = [];
            this.cols.map((col) => {
                if (col.sumUp.substring(0, "sum.".length) === "sum.") {
                    sumCol.push(col.label);
                }
            });
            columns.forEach((column, index) => {
                if (index === 0 || index === 1) {
                    return;
                }
                if (sumCol.indexOf(column.label) !== -1) {
                    sums[index] = 0;
                    var prop = "";
                    var fix = 0;
                    data.map((row) => {
                        this.cols.map((col) => {
                            if (column.label === col.label) {
                                prop = col.prop;
                                fix = parseInt(
                                    col.sumUp.replaceAll("sum.", "")
                                );
                            }
                        });
                        sums[index] += Number(row[prop] ? row[prop] : 0);
                    });
                    sums[index] = sums[index].toFixed(fix);
                } else {
                    this.cols.map((col) => {
                        if (col.label === column.label) {
                            sums[index] = col.sumUp;
                        }
                    });
                }
            });

            return sums;
        },
        accountSelected() {
            this.$nextTick(() => {
                this.$refs.accountList.checkAccount();
            });
        },
        employeeSelected() {
            this.$nextTick(() => {
                this.$refs.saleList.checkEmployee();
            });
        },
        closeAccount(value) {
            this.orderForm.accountname = "";
            this.orderForm.accountid = value[0].id;
            this.orderForm.accountname = value[0].name;
            this.accountListDialog = false;
        },
        closeEmployee(value) {
            this.orderForm.emp = value[0].id;
            this.orderForm.empname = "";
            this.orderForm.empname = value[0].name;
            this.saleListDialog = false;
        },
        closeProductList(value) {
            let curIndex = this.curRow.id - 1;
            let productSelect = value[0];
            let row = {};
            productSelect.forEach(e=>{
                e.specs.forEach(s=>{
                    if(s.count>0||s.num>0){
                        var canUseUnit = s.stock - s.notSendUnit;
                        var spec = s.color?"-"+s.color +"-" +s.size:"";
                        row = {
                            id: "",
                            image:e.image.length>0?e.image:[],
                            name:e.number+" "+e.name+spec,
                            packing: s.unit + "双/" + e.packing,
                            count: s.count,
                            small: s.num,
                            price: s.price,
                            sum: "",
                            remark: s.remark,
                            unitCount: s.unit,
                            pid: e.id,
                            spid: s.id,
                            countEdit: false,
                            nameEdit: false,
                            priceEdit: false,
                            remark: "",
                            remarkEdit: false,
                            smallEdit: false,
                            minstock : s.minstock,
                            notSendUnit : s.notSendUnit,
                            mdesc : this.$common.changeNumDesc(s,'stockAmount','stockParts','stock'),
                            ndesc : this.$common.changeNumDesc(s,'notSendAmount','notSendParts','notSendUnit'),
                            
                            edesc : this.$common.changeSendDesc(canUseUnit,s.unit),
                            stock : s.stock,
                        };
                        row.unit = row.count * row.unitCount + row.small;
                        row.sum = (row.unit*row.price).toFixed(2);
                        if (this.orderForm.detailL[curIndex].name) {
                            this.orderForm.detailL.splice(curIndex, 0, row);
                        } else {
                            this.orderForm.detailL.splice(curIndex, 1, row);
                        }
                        if (!this.orderForm.detailL[curIndex + 1]) {
                            this.orderForm.detailL.push({
                                id: "",
                                image: [],
                                name: "",
                                packing: "",
                                count: "",
                                small: "",
                                price: "",
                                sum: "",
                                remark: "",
                                countEdit: false,
                                nameEdit: false,
                                priceEdit: false,
                                remarkEdit: false,
                                smallEdit: false,
                            });
                            this.number++;
                        }
                        curIndex++;
                    }
                })
            })
            for (let i = 0; i < this.orderForm.detailL.length; i++) {
                this.orderForm.detailL[i].id = i + 1;
            }
            this.productListDialog = false;
            this.$nextTick(()=>{
                this.$refs.proList.clearSelect();
            })
        },
        proSelected() {
            this.$nextTick(() => {
                this.$refs.proList.selectProduct();
            });
        },
        selectCustomer(id) {
            this.orderForm.cid = id;
            this.$nextTick(() => {
                this.$refs.paddr.init((info)=>{
                    if(info){
                        this.orderForm.invoice = info.invoice;
                        this.orderForm.taxidentification = info.taxIdentification;
                        this.orderForm.cname = info.cname;
                        this.orderForm.cid = info.id;
                        this.orderForm.invoiceaddress = info.invoiceaddress;
                        this.orderForm.invoicephone = info.invoicephone;
                        this.orderForm.bankname = info.bankname;
                        this.orderForm.bankaccountnumber =info.bankaccountnumber;
                        this.invoiceform = info;
                        if(info.district&&info.district.length>0){
                            this.orderForm.district = info.district;
                            this.orderForm.label = info.district.join('');
                            this.orderForm.address = info.address;
                        }else{
                            this.orderForm.district = [];
                            this.orderForm.label = '';
                            this.orderForm.address = '';
                        }
                        
                    }else{
                        this.orderForm.cid = 0;
                        this.$global.cid = 0;
                    }
                });
                
            });
            this.getProduct();
        },
        selectEmployee(value) {
            this.orderForm.emp = value;
        },
        empSetDefault() {
            this.saleListDialog = true;
            this.$nextTick(() => {
                this.$refs.saleList.defaultSelect();
            });
        },
        productMany(row) {
            this.productListDialog = true;
            this.curRow = row;
		},
		changedate(){
            let olddate = this.$common.dateStringtoTime(this.orderForm.date);
            if(this.orderForm.expect){
                let newdate = this.$common.dateStringtoTime(this.orderForm.expect);
                if(newdate<olddate){
                    this.orderForm.expect = this.orderForm.date;
                }
            }
		},
        setAccount(id) {
            for(let i=0;i<this.acList.length;i++){
                if(this.acList[i].id==id){
                    this.orderForm.accountid = id;
                    this.orderForm.accountname = this.acList[i].name;
                    break;
                }
            } 
        },
        checkCustomer(){
            if(this.orderForm.cid>0){
                this.saveOrder();
            }else if(this.orderForm.cid===0){
                this.$nextTick(()=>{
                    this.$refs.ccc.addCustomer((res)=>{
                        this.saveOrder();
                    });
                })
            }else{
                this.$common.error("没有选择客户");
            }
        },
        saveOrder() {
            if(this.$global.useinstall==1){
                if(!this.orderForm.method){
                    this.$common.error("没有选择货运方式");
                    return;
                }
                if(!this.orderForm.address){
                    this.$common.error("没有填写详细地址");
                    return;
                }
            }
            const confirmText = [
                "请确保订单中的商品名称填写完成，",
                "若未填写则不会保存！！",
            ];
            const newData = [];
            const h = this.$createElement;
            for (const i in confirmText) {
                newData.push(h("p", null, confirmText[i]));
            }
            this.$confirm("警告", {
                title: "警告",
                message: h("div", null, newData),
                showCancelButton: true,
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(
                () => {
                    this.orderForm.detail = this.orderForm.detailL.filter(
                        (item) => item.name&&(item.count>0||item.small>0)
                    );
                    this.orderForm.attach = this.orderForm.attachL.toString();
                    this.orderForm.detail.map((item) => {
                        item.image = item.image.map((img) => {
                            return img.replaceAll(this.imgProfit, "");
                        });
                    });
                    this.orderForm.detail = JSON.stringify(
                        this.orderForm.detail
                    );
                    this.$api.orderaddOrder(this.orderForm).then((res) => {
                        if(res.data.code==1){
                            this.$nextTick(()=>{
                                let arr = []
                                arr.push(res.data.data);
                                this.$refs.roder.extraCheckOpen(0,arr,()=>{
                                    if(this.$common.hasLimits("order")){
                                        this.$router.push({
                                        path: "/order",
                                        query:{type:this.orderForm.type},
                                    });
                                    }else{
                                        this.$router.push("/product");
                                    }
                                    this.$notify({
                                        title: "新增订货",
                                        message: "订货成功",
                                        type: "success",
                                        duration: 1500,
                                    });
                                });
                            })
                        }
                    });
                },
                () => {}
            );
        },
        cancelInvoice() {
            this.invoiceDialog = false;
            if (this.orderForm.invoicetype == 1) {
                if (
                    !this.orderForm.invoice ||
                    !this.orderForm.taxidentification
                ) {
                    this.orderForm.invoicetype = 0;
                }
            } else if (this.orderForm.invoicetype == 2) {
                if (
                    !this.orderForm.invoice ||
                    !this.orderForm.taxidentification ||
                    !this.orderForm.invoiceaddress ||
                    !this.orderForm.invoicephone ||
                    !this.orderForm.bankname ||
                    !this.orderForm.bankaccountnumber
                ) {
                    this.orderForm.invoicetype = 0;
                }
            }
        },
        saveInvoice() {
            this.$refs.invoiceform.validate((valid) => {
                if(valid){
                    if (this.orderForm.invoicetype == 1) {
                        // 普通发票
                        this.$api.customereditCustomerInvoice({
                            id: this.orderForm.cid,
                            invoice: this.invoiceform.invoice,
                            taxIdentification: this.invoiceform.taxIdentification,
                        }).then((res) => {
                            this.invoiceDialog = false;
                            this.$notify({
                                title: "设置发票信息",
                                message: "设置成功",
                                type: "success",
                                duration: 1000,
                                onClose: () => {
                                    this.orderForm.invoice = this.invoiceform.invoice;
                                    this.orderForm.taxidentification = this.invoiceform.taxIdentification;
                                },
                            });
                        });
                    } else if (this.orderForm.invoicetype == 2) {
                        // 专用发票
                        this.$api.customereditCustomerInvoice({
                            id: this.orderForm.cid,
                            invoice: this.invoiceform.invoice,
                            taxIdentification: this.invoiceform.taxIdentification,
                            invoiceaddress: this.invoiceform.invoiceaddress,
                            invoicephone: this.invoiceform.invoicephone,
                            bankname: this.invoiceform.bankname,
                            bankaccountnumber: this.invoiceform.bankaccountnumber,
                        }).then((res) => {
                            this.invoiceDialog = false;
                            this.$notify({
                                title: "设置发票信息",
                                message: "设置成功",
                                type: "success",
                                duration: 1000,
                                onClose: () => {
                                    this.orderForm.invoice = this.invoiceform.invoice;
                                    this.orderForm.taxidentification = this.invoiceform.taxIdentification;
                                    this.orderForm.invoiceaddress = this.invoiceform.invoiceaddress;
                                    this.orderForm.invoicephone = this.invoiceform.invoicephone;
                                    this.orderForm.bankname = this.invoiceform.bankname;
                                    this.orderForm.bankaccountnumber = this.invoiceform.bankaccountnumber;
                                },
                            });
                        });
                    }
                }
            })
        },
    },
};
</script>

<style lang="scss" scoped>
.productList {
    position: absolute;
    right: 20px;
    height: 34px;
    line-height: 34px;
    background: #fff;
    top: 11px;
}
.number_size{
    position: absolute;
    display: flex;
    right: 0px;
    top: -72px;
    font-size: 18px;
    line-height: 40px;
}
</style>

